import { AxiosError } from 'axios';

export const isAxiosError = (error: unknown): error is AxiosError => (error as AxiosError).isAxiosError;

export const isAxiosErrorWithHttpStatus = (error: unknown, status: number): error is AxiosError =>
    isAxiosError(error) && error.response?.status === status;
